import {
  Article,
  ArticleImage,
  ArticleSubtitle,
  ArticleTitle,
} from "@babackapp/customer-ui/components/article";
import type { SearchReturnRequestsResponseDto } from "@babackapp/private-api-client";
import { DiscountedPrice } from "@babackapp/return-widget-components/components/discounted-price";
import { parseLineItemPriceInCents } from "@babackapp/return-widget-components/utils/get-line-item-price";

type LineItem = SearchReturnRequestsResponseDto["returnRequests"][number]["line_items"][number];

type Props = {
  lineItem: LineItem;
  currency: string;
  imageLayoutId?: string;
};

export function ReturnRequestLineItem({ lineItem, currency, imageLayoutId }: Props) {
  const catalogPriceCents = parseLineItemPriceInCents(lineItem.price);
  const paidPriceCents =
    parseLineItemPriceInCents(lineItem.paidPrice) ?? catalogPriceCents;

  return (
    <Article variants={{}}>
      {lineItem.image && (
        <ArticleImage src={lineItem.image} layoutId={imageLayoutId} />
      )}
      <ArticleTitle>{lineItem.title}</ArticleTitle>
      <ArticleSubtitle>
        ×{lineItem.quantity}
        {catalogPriceCents != null && paidPriceCents != null && (
          <>
            {" — "}
            <DiscountedPrice
              catalogCents={catalogPriceCents}
              paidCents={paidPriceCents}
              currency={currency}
            />
          </>
        )}
      </ArticleSubtitle>
    </Article>
  );
}
